import { DEFAULT_LANGUAGE, LOCAL_STORAGE_KEY } from './constant'
import getEnvConfig from 'next/config'
// import localStorage from 'local-storage'

const { publicRuntimeConfig } = getEnvConfig()

export const getCurrentlanguage = (language) => {
  let lang = DEFAULT_LANGUAGE
  if (process.browser && localStorage.getItem(LOCAL_STORAGE_KEY.LANG)) {
    lang = localStorage.getItem(LOCAL_STORAGE_KEY.LANG)
  } else {
    lang = language || DEFAULT_LANGUAGE
  }
  return lang
}

export const getConfig = (key) => publicRuntimeConfig[key]

export const scrollTop = () => process.browser && window.scrollTo(0,0)
